export default function (el, options) {
    return import(/* webpackChunkName: "IMask" */ 'IMask').then(({default: IMask}) => {
        return new IMask(el, options)
    });
}